module.exports = __webpack_public_path__ + "img/phase1-2012-02.ef7bba07.jpg";